import { render, staticRenderFns } from "./AppWeekdayButton.vue?vue&type=template&id=2f99e742&"
import script from "./AppWeekdayButton.vue?vue&type=script&lang=ts&"
export * from "./AppWeekdayButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports